export function getMinValue(value: number): number {
  // does not work with exponential number cast
  const zeros = '0'.repeat(Math.trunc(value).toString().length - 1);
  return parseInt(`1${zeros}`, 10);
}
